export default __webpack_public_path__ + "static/media/cb_failed.46b2fd72.png";